import React, { PropsWithChildren } from 'react';
import { FormRenderProps } from 'react-final-form';
// import { unstable_usePrompt as usePrompt } from 'react-router-dom';

export interface OfferFormProps<T> {
  handleSubmit: FormRenderProps<T>['handleSubmit'];
  dirty: boolean;
}

export function OfferForm<T>(props: PropsWithChildren<OfferFormProps<T>>) {
  const { handleSubmit } = props;
  // usePrompt({ // TODO available only with React Router Data API
  //   when: dirty,
  //   message: 'You have unsaved changes. Are you sure you want to go to another page?',
  // });

  return <form onSubmit={handleSubmit}>{props.children}</form>;
}
